import React, { Component } from "react"
import { SketchPicker } from "react-color"
import reactCSS from "reactcss"
export default class ColorSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            displayColorPicker: false,
            color: props.color,
        }
    }

    handleChangeColorButton = (e) => {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout)
        }
        this.searchTimeout = setTimeout(() => {
            this.props.changeColor(e)
        }, 200)
    }

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    }

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    }

    handleChange = (color) => {
        this.setState({ color: color.hex })
        this.handleChangeColorButton(color.hex)
    }

    render() {
        const { text, general } = this.props
        const { color } = this.state
        let width = "80px"
        let height = "16px"
        let padding = "5px"
        if (general) {
            width = "50px"
            height = "20px"
            padding = "0px"
        }

        const styles = reactCSS({
            default: {
                color: {
                    width: width,
                    height: height,
                    borderRadius: "2px",
                    background: `${color}`,
                },
                swatch: {
                    padding: padding,
                    background: "#89898a",
                    borderRadius: "1px",
                    boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
                    display: "inline-block",
                    cursor: "pointer",
                },
                popover: {
                    position: "absolute",
                    zIndex: "2",
                },
                cover: {
                    position: "fixed",
                    top: "0px",
                    right: "0px",
                    bottom: "0px",
                    left: "0px",
                },
            },
        })

        return (
            <div className="icon-wh">
                <div className="label">{text}</div>
                {/* <input
                    type="color"
                    value={color}
                    onChange={(e) => this.handleChangeColorButton(e.target.value)}
                /> */}
                <div>
                    <div style={styles.swatch} onClick={this.handleClick}>
                        <div style={styles.color} />
                    </div>
                    {this.state.displayColorPicker ? (
                        <div style={styles.popover}>
                            <div style={styles.cover} onClick={this.handleClose} />
                            <SketchPicker
                                color={color}
                                onChange={this.handleChange}
                                presetColors={[
                                    "#F0F0F0",
                                    "#111313",
                                    "#2B8160",
                                    "#CCCCCC",
                                    "#2E72D2",
                                    "#D82D0D",
                                    "#F9C454",
                                    "#5BCDDA",
                                ]}
                            />
                        </div>
                    ) : null}
                </div>
            </div>
        )
    }
}
